import { FC } from "react";
import { Box } from "@mui/material";
import ArrowBackSvg from "@/assets/svg/ArrowBackSvg";
import logoImg from "@/assets/image/logo.png";

interface HeaderControlProps {
  onClick: () => void;
  left?: string;
  top?: string;
  logo?: boolean;
}

const HeaderControl: FC<HeaderControlProps> = ({
  onClick,
  left = "0px",
  top = "0px",
  logo = false,
}) => {
  return (
    <Box
      position="absolute"
      left={left}
      top={top}
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: "163px",
        alignItems: "center",
        height: "56px",
      }}
    >
      <Box
        sx={{ cursor: "pointer", marginLeft: "16px", height: "24px", width: "24px" }}
        onClick={onClick}
      >
        <ArrowBackSvg />
      </Box>
      {logo && (
        <Box>
          <img
            src={logoImg}
            alt="Wethemrkt Logo"
            width={115}
            height={36}
            style={{ objectFit: "contain" }}
          />
        </Box>
      )}
    </Box>
  );
};

export default HeaderControl;
